import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { datadogRum } from "@datadog/browser-rum";
import App from "./App";
import { Splash } from "./components/blocks";
import { inicializarFirebase } from "./firebaseConfig";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

datadogRum.init({
  applicationId: "faf7e87b-3c7e-48b6-82b5-bde3b53fdb73",
  clientToken: "pub76ffd20233451574d046f58afe2fab16",
  site: "datadoghq.com",
  service: "app-club-3",
  sampleRate: 100,
  trackInteractions: true,
  defaultPrivacyLevel: "mask-user-input",
  allowedTracingOrigins: [
    "https://app.dreamsclub.pe",
    "https://app.dreamsclub.com.pe",
    "https://salaqueens.com",
    "https://queenstest.wargos.cloud",
    "https://api4.wargos.cloud",
  ],
});

datadogRum.startSessionReplayRecording();

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
const SPLASH_SESSION_KEY = "app_splash_seen";

const getInitialSplashState = () => {
  try {
    return sessionStorage.getItem(SPLASH_SESSION_KEY) !== "true";
  } catch (error) {
    return true;
  }
};

function RootWithSplash() {
  const [showSplash, setShowSplash] = useState(getInitialSplashState);
  const [isSplashVisible, setIsSplashVisible] = useState(getInitialSplashState);
  const [isAppVisible, setIsAppVisible] = useState(!getInitialSplashState());

  useEffect(() => {
    if (!showSplash) {
      return undefined;
    }

    const revealTimer = setTimeout(() => {
      setIsAppVisible(true);
      setIsSplashVisible(false);
    }, 1600);

    const cleanupTimer = setTimeout(() => setShowSplash(false), 2100);

    return () => {
      clearTimeout(revealTimer);
      clearTimeout(cleanupTimer);
    };
  }, [showSplash]);

  useEffect(() => {
    if (!showSplash) {
      try {
        sessionStorage.setItem(SPLASH_SESSION_KEY, "true");
      } catch (error) {
      }
    }
  }, [showSplash]);

  return (
    <QueryClientProvider client={queryClient}>
      <div className={`transition-opacity duration-500 ease-out ${isAppVisible ? "opacity-100" : "opacity-0"}`}>
        <App />
      </div>
      {showSplash && <Splash visible={isSplashVisible} />}
    </QueryClientProvider>
  );
}

root.render(
  <React.StrictMode>
    <RootWithSplash />
  </React.StrictMode>
);

reportWebVitals();
serviceWorkerRegistration.register();
inicializarFirebase();
